import { ConditionType } from '../Model/ConditionType';
import { ConditionKind } from '../Model/ConditionKind';
import { UrlMatchCondition, UrlNotMatchCondition, LocationMatchCondition } from '../Condition/UrlMatchCondition';
import { ShowFromDateCondition } from '../Condition/ShowFromDateCondition';
import { ShowUntilDateCondition } from '../Condition/ShowUntilDateCondition';
var ConditionFactory = /** @class */ (function () {
    function ConditionFactory() {
    }
    ConditionFactory.build = function (models) {
        var factories = [
            new LocationMatchConditionAggregatedFactory(),
            new ConditionWithParameterAggregatedFactory()
        ];
        models.forEach(function (model) {
            var accepted = false;
            factories.forEach(function (factory) {
                accepted = !accepted && factory.accept(model);
            });
        });
        var conditions = [];
        factories.forEach(function (factory) {
            conditions = conditions.concat(factory.build());
        });
        return conditions;
    };
    return ConditionFactory;
}());
export { ConditionFactory };
var LocationMatchConditionAggregatedFactory = /** @class */ (function () {
    function LocationMatchConditionAggregatedFactory() {
        this._models = [];
    }
    LocationMatchConditionAggregatedFactory.prototype.accept = function (model) {
        if (model.type === ConditionType.WithParameter
            && (model.kind === ConditionKind.UrlMatch || model.kind === ConditionKind.UrlNotMatch)) {
            this._models.push(model);
            return true;
        }
        return false;
    };
    LocationMatchConditionAggregatedFactory.prototype.build = function () {
        var conditions = this._models.map(function (model) {
            return ConditionWithParameterFactory.build(model);
        }).filter(function (condition) {
            return condition !== null;
        });
        return [
            new LocationMatchCondition(conditions)
        ];
    };
    return LocationMatchConditionAggregatedFactory;
}());
var ConditionWithParameterAggregatedFactory = /** @class */ (function () {
    function ConditionWithParameterAggregatedFactory() {
        this._models = [];
    }
    ConditionWithParameterAggregatedFactory.prototype.accept = function (model) {
        if (model.type === ConditionType.WithParameter) {
            this._models.push(model);
            return true;
        }
        return false;
    };
    ConditionWithParameterAggregatedFactory.prototype.build = function () {
        return this._models.map(function (model) {
            return ConditionWithParameterFactory.build(model);
        }).filter(function (condition) {
            return condition !== null;
        });
    };
    return ConditionWithParameterAggregatedFactory;
}());
var ConditionWithParameterFactory = /** @class */ (function () {
    function ConditionWithParameterFactory() {
    }
    ConditionWithParameterFactory.build = function (model) {
        switch (model.kind) {
            case ConditionKind.UrlMatch:
                return new UrlMatchCondition(model);
            case ConditionKind.UrlNotMatch:
                return new UrlNotMatchCondition(model);
            case ConditionKind.ShowFromDate:
                return new ShowFromDateCondition(model);
            case ConditionKind.ShowUntilDate:
                return new ShowUntilDateCondition(model);
            default:
                return null;
        }
    };
    return ConditionWithParameterFactory;
}());
